import React, { useState, useEffect, useRef } from "react";
// import "./ContactUsNew.css";
// import WhyUsSmall from "../../../Assets/Why-Us-SmallImage.jpg";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getCity,
  setCity,
  getCall,
  postFrenchiseInfo,
} from "../../Redux/Actions";
import { FiMail, FiPhone } from "react-icons/fi";
import { FaUserCircle, FaMapPin } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import { useLocation } from "react-router";
// import "../../packageDetailsPage/Newlp.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PatientActions from "../../components/Cart/PatientDetailsAction";
import ImagingLpForm from "../../components/Redcliffe-Imaging/Homepage/ImagingLpForm";

function ContactUsNew(props) {
  const { page, telNumber, email, frenchise, data1, data2 } = props;

  const [userName, setUserName] = useState("");
  const [userMessage, setMessage] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userCity, setUserCity] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [displayCityList, setDisplay] = useState(true);
  const [loginForm, setLoginForm] = useState(true);
  const [success, setSucess] = useState(false);
  const [checkboxState, setCheckboxState] = useState(true);

  // console.log(props?.userProfile, "user avai <<<<")
  useEffect(() => {
    dispatch(getCity());
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (token) {
      props?.getProfileDetails(token);
    }
  }, []);

  //calling city name api

  useEffect(() => {
    if (props?.userProfile?.username) {
      setUserNumber(props?.userProfile?.phonenumber);
      setUserName(props?.userProfile?.fullname);
    } else {
      setUserNumber("");
      setUserName("");
    }
  }, [props?.userProfile]);

 
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  console.log("cityies", citiesFromArray);
  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;

  const dispatch = useDispatch();

  //use location imported
  const location = useLocation();

  var url = `https://redcliffelabs.com/imaging`;

  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    setUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number");
      return false;
    } else {
      return true;
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      const body = {
        optin: checkboxState,
        name: userName,
        phone_no: userNumber,
        source: "Imaging",
        city: userCity,
        url,
        message: userMessage,
      };

      const frenchiseBody = {
        name: userName,
        mobile: userNumber,
        city_name: userCity,
        message: userMessage,
        url,
      };
      console.log(body);
      setUserNumber("");
      setUserName("");
      setUserCity("");
      setMessage("");
      setSucess(true);
      setTimeout(() => {
        setSucess(false);
      }, 2000);

      frenchise
        ? dispatch(postFrenchiseInfo(frenchiseBody))
        : dispatch(getCall(body));
    }
  };

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1003,
      }}
      id="modalId"
      onClick={(e) => {
        e.target.id === "modalId" && props.close();
      }}
    >
      <form
        className={loginForm ? "modal-form login-form " : "hide"}
        onSubmit={handelSubmit}
        // style={{ width: "45vw" }}
      >
        <div className="form__div">
          <h2
            style={{
              fontSize: "3rem",
              margin: "2rem 0",
              color: "#707070",
            }}
            className="ForMargin"
          >
            Get In Touch With Us
          </h2>
          <p className="para1 ForMargin">
            Feel Free to Connect With Us For Any Queries
          </p>
          <div>
            <div className="form__input ForMargin">
              <span className="userIcon">
                <FaUserCircle />
              </span>
              <div className="inputDiv">
                <input
                  type="text"
                  placeholder="Enter Name"
                  onChange={handelUserName}
                  value={userName}
                  style={{ marginBottom: 0 }}
                />
              </div>
            </div>
            <span className="FormError">{nameError}</span>
          </div>

          <div>
            <div className="form__input numBox ForMargin">
              <span className="numIcon">+91</span>
              <div className="inputDiv">
                <input
                  type="text"
                  placeholder="Enter Phone Number"
                  required
                  onChange={handelPhoneChange}
                  value={userNumber}
                  style={{ marginBottom: 0 }}
                />
              </div>
            </div>
            <span className="FormError">{phoneError}</span>
          </div>

          <div
            className="citySelect ForMargin"
            style={{ padding: "0", marginBottom: "8px" }}
          >
            <span className="locIcon">
              <FaMapPin />
            </span>

            <input
              type="text"
              placeholder="Enter City"
              onChange={handelCityChange}
              value={userCity}
              style={{ marginBottom: 0 }}
            />
          </div>

          <div className={userCity ? "cityList" : "displayNone"} id="cityList">
            {userCity !== "" && citiesFromArray && citiesFromArray.cities
              ? citiesFromArray.cities
                  .filter((name) => {
                    if (userCity == "") {
                      return name;
                    } else if (
                      name.toLowerCase().includes(userCity.toLowerCase())
                    ) {
                      return name;
                    }
                  })
                  .map((values, index) => {
                    if (index < 2) {
                      return (
                        <>
                          <div
                            onClick={() => setInputcity(values)}
                            key={index}
                            className={
                              displayCityList ? "cityLIstLP" : "displayNone"
                            }
                          >
                            <span>{values}</span>
                          </div>
                        </>
                      );
                    }
                  })
              : null}
          </div>
          {frenchise ? (
            <div>
              <textarea
                required
                placeholder="Type your message here*"
                value={userMessage}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
          ) : null}
          {frenchise ? null : (
            <div className="opt_Div">
              <input
                type="checkbox"
                onChange={() => handleCheckChange()}
                defaultChecked
                style={{
                  width: "22px",
                  height: "22px",
                  marginBottom: "0",
                }}
              />
              <span className="watsap">
                <RiWhatsappFill
                  style={{ fontSize: "2.5rem", color: "#2bcc57" }}
                />
              </span>
              <span className="textt">Opt-in for WhatsApp updates</span>
            </div>
          )}

          {success ? (
            <span className="success">
              Your form has been submitted successfully!
            </span>
          ) : null}
          <button
            type="submit"
            disabled={nameError ? "disabled" : ""}
            className={nameError ? "disabled" : ""}
          >
            SUBMIT
          </button>
        </div>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(ContactUsNew));
